module.exports = __webpack_public_path__ + "static/media/S1N10.4578d215.svg";